import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { clearAuthFlags, fetchUserRole } from 'actions/authentication';
import { clearBookingFlags, processQueuedBookings } from 'actions/booking';
import { clearIQOSFlags, processQueuedLeads } from 'actions/iqos';
import {
  clearVenueFlags,
  fetchDefaultVenue,
  fetchVenueDetails,
  setDefaultVenue,
  setVenueDetails,
} from 'actions/venue';
import React from 'react';
import { isIOS } from 'react-device-detect';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import './index.scss';
import { navigationElementsForVenue } from './navigation.js';
import VenueSwitcher from './VenueSwitcher';

class MegaNav extends React.Component {
  state = {
    showVenueSwitcher: false,
    extendedNavigation: false,
    selectedNavElement: {},
    shouldReload: false,
    windowResize: false,
    loading: false,
  };

  generateTabNavigationBar = () => {
    const rootPath = this.props.location.pathname.split('/')[2];
    const tabNavElements = navigationElementsForVenue(this.props.venue);

    const filteredTabNavElements = this.props.permissions
      ? tabNavElements.filter(element => {
          return this.props.permissions.includes(element.root);
        })
      : [];

    return filteredTabNavElements.map((element, index) => {
      const hideClientsFeature =
        this.props.venue.clients_enabled === false &&
        element.root === 'clients';
      const hideMultiVenueFeature =
        this.props.venue.multi_venue_enabled === false &&
        element.root === 'multi-venue';

      const showTabAsLink = element.children === undefined;
      const isActiveTab = element.root === rootPath;
      const key = `tab-nav-${element.title}`;
      const className = `meganav__tab__bar__item ${
        isActiveTab ? 'meganav__tab__bar__item--active' : ''
      }${
        hideClientsFeature || hideMultiVenueFeature
          ? 'meganav__tab__bar__item--hidden'
          : ''
      }`;

      const tabDetails = (
        <div>
          {element.icon ? (
            <Icon className="meganav__tab__bar__icon i">{element.icon}</Icon>
          ) : (
            <img
              alt="icon"
              className="meganav__tab__bar__icon__image"
              src={`/img/icons/${element.iconImage}.png`}
            />
          )}

          <div className="meganav__tab__bar__content">
            <p
              style={{
                color: isActiveTab && '#000',
              }}
            >
              {element.title}
            </p>
          </div>
        </div>
      );

      const linkTab = (
        <Link
          key={key}
          onClick={() => this.closeChildNavigation()}
          to={`/dashboard/${element.root}/`}
          className={className}
        >
          {tabDetails}
        </Link>
      );

      const expandableTab = (
        <div
          key={key}
          onClick={() => this.openChildNavigation(element)}
          className={className}
        >
          {tabDetails}
        </div>
      );

      return showTabAsLink ? linkTab : expandableTab;
    });
  };

  generateChildNavigationBar = () => {
    const selectedNav = this.state.selectedNavElement;
    const selectedNavChildren = selectedNav.children || [];
    const selectedNavRootPath = `/dashboard/${selectedNav.root}/`;

    const locations = this.props.location.pathname.split('/');
    const childPath = locations.length >= 4 ? locations[3] : '';
    const parentPath = locations.length >= 3 ? locations[2] : '';

    return (
      <div className="meganav__child__bar__container" id="account__container">
        {selectedNavChildren.map(element => {
          const isActiveChild =
            parentPath === selectedNav.root && childPath === element.route;
          const key = `child-nav-link-${element.title}`;
          const linkTo = `${selectedNavRootPath}${element.route}`;
          const clickHandler = () =>
            this.setState({ extendedNavigation: false });
          const className = `meganav__child__bar__item ${
            isActiveChild ? 'meganav__child__bar__item--active' : ''
          }`;

          return (
            <Link
              key={key}
              onClick={clickHandler}
              to={linkTo}
              className={className}
            >
              {element.title}
            </Link>
          );
        })}
      </div>
    );
  };

  openChildNavigation(tabNavElement) {
    var extendNavigation = !this.state.extendedNavigation;

    if (tabNavElement.title !== this.state.selectedNavElement.title) {
      extendNavigation = true;
    }

    this.setState({
      extendedNavigation: extendNavigation,
      selectedNavElement: tabNavElement,
    });
  }

  closeChildNavigation() {
    this.setState({
      extendedNavigation: false,
    });
  }

  showVenueSwitcher() {
    this.setState({
      showVenueSwitcher: true,
    });
  }

  logout() {
    if (window.confirm('Are you sure you wish to logout?')) {
      window.persistor.purge().then(() => {
        setTimeout(() => {
          window.localStorage.clear();
          window.location.href = '/';
        }, 100);
      });
    }
  }

  closeVenueSwitcher() {
    this.setState({
      showVenueSwitcher: false,
    });
  }

  componentWillMount() {
    this.props.processQueuedBookings();
    this.props.processQueuedLeads();
    this.props.clearVenueFlags();
    this.props.clearBookingFlags();
    this.props.clearIQOSFlags();
    this.props.clearAuthFlags();

    window.addEventListener('resize', () => {
      this.setState({ windowResize: !this.state.windowResize });
    });

    if (!this.props.defaultVenue && !this.props.fetchingDefaultVenue) {
      this.props.fetchDefaultVenue();
    } else {
      this.props.fetchVenueDetails();
    }
  }

  componentDidUpdate(nextProps) {
    // We have changed venues... reload in a hackish way :(
    if (nextProps._id && nextProps._id !== this.props._id) {
      setTimeout(() => {
        window.location.reload();
      }, 200);
    }

    if (
      !this.props.fetchingVenue &&
      this.props.defaultVenue &&
      !this.props._id
    ) {
      this.props.fetchVenueDetails();
    }

    if (
      !this.props.fetchingUserRole &&
      !this.props.user &&
      this.props.defaultVenue
    ) {
      this.props.fetchUserRole();
    }
  }

  switchVenue(venue) {
    localStorage.removeItem('hasShownSetup');

    this.props.setDefaultVenue(venue._id);
    this.props.setVenueDetails(venue);
    this.closeVenueSwitcher();

    this.setState({ shouldReload: true });
  }

  render() {
    const tabNav = this.generateTabNavigationBar();
    const childNav = this.generateChildNavigationBar();

    const showSwitcher =
      (!this.props.defaultVenue && !this.props.fetchingDefaultVenue) ||
      this.state.showVenueSwitcher;

    const name = this.props.name || '-';
    const user = this.props.user || { forename: '', surname: '', email: '' };

    return (
      <React.Fragment>
        <span>
          {this.props.fetchingDefaultVenue ? <Loader fullPage loading /> : null}

          <div className={`meganav__header`}>
            <h3 className={`meganav__header__title`}>{name}</h3>
            <div className="meganav__information">
              <div className="meganav__actions">
                <span className="meganav__actions__item">
                  <IconButton
                    onClick={() => this.showVenueSwitcher()}
                    className="i meganav__actions__item__button"
                    aria-label="Switch Venue"
                  >
                    <Icon className="meganav__actions__item__icon">
                      swap_horiz
                    </Icon>
                  </IconButton>
                </span>
                <span className="meganav__actions__item">
                  <IconButton
                    onClick={() =>
                      window.open('https://intercom.help/tabb/en/', '_blank')
                    }
                    className="i meganav__actions__item__button"
                    aria-label="Help"
                  >
                    <Icon className="meganav__actions__item__icon">help</Icon>
                  </IconButton>
                </span>
                <span className="meganav__actions__item">
                  <IconButton
                    onClick={() =>
                      this.props.history.push('/dashboard/settings')
                    }
                    className="i meganav__actions__item__button"
                    aria-label="Settings"
                  >
                    <Icon className="meganav__actions__item__icon  meganav__actions__item__settings">
                      settings
                    </Icon>
                  </IconButton>
                </span>
                <span className="meganav__actions__item">
                  <IconButton
                    onClick={() => this.logout()}
                    className="i meganav__actions__item__button"
                    aria-label="Logout"
                  >
                    <Icon className="meganav__actions__item__icon meganav__actions__item__logout">
                      exit_to_app
                    </Icon>
                  </IconButton>
                </span>
              </div>
              <div className="meganav__user__details">
                <span className="meganav__user__name">
                  {user.forename} {user.surname}
                </span>
                <span className="meganav__user__email">{user.email}</span>
              </div>
            </div>
          </div>

          <div
            className={`meganav__outer ${
              this.state.extendedNavigation ? 'meganav__outer--hover' : ''
            }`}
            style={
              window.innerWidth > 900
                ? {
                    height: isIOS ? 'calc(100vh - 80px)' : 'calc(100vh - 80px)',
                  }
                : {}
            }
          >
            <div
              className="meganav__tab__bar"
              style={
                window.innerWidth > 900
                  ? { height: isIOS ? '100%' : 'calc(100vh - 80px)' }
                  : {}
              }
            >
              {tabNav}
            </div>
            <div className="meganav__child__bar">{childNav}</div>
          </div>

          <VenueSwitcher
            locked={!this.props.defaultVenue}
            open={showSwitcher}
            onClose={() => this.closeVenueSwitcher()}
            onVenueSelect={venue => this.switchVenue(venue)}
          />
        </span>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const token = state.authentication.accessToken;
  const {
    fetchingDefaultVenue,
    fetchingVenue,
    venueFetchError,
    defaultVenue,
    _id,
    name,
  } = state.venue;
  const venue = state.venue;

  const { fetchingUserRole, user, role, permissions } = state.authentication;
  const error = state.error;

  return {
    token,
    fetchingUserRole,
    user,
    role,
    permissions,
    venue,
    fetchingDefaultVenue,
    fetchingVenue,
    venueFetchError,
    defaultVenue,
    _id,
    name,
    error,
  };
};

const mapDispatchToProps = dispatch => ({
  processQueuedBookings: () => dispatch(processQueuedBookings()),
  processQueuedLeads: () => dispatch(processQueuedLeads()),
  fetchDefaultVenue: () => dispatch(fetchDefaultVenue()),
  fetchVenueDetails: () => dispatch(fetchVenueDetails()),
  fetchUserRole: () => dispatch(fetchUserRole()),
  setDefaultVenue: defaultVenue => dispatch(setDefaultVenue(defaultVenue)),
  setVenueDetails: venue => dispatch(setVenueDetails(venue)),
  clearVenueFlags: () => dispatch(clearVenueFlags()),
  clearBookingFlags: () => dispatch(clearBookingFlags()),
  clearIQOSFlags: () => dispatch(clearIQOSFlags()),
  clearAuthFlags: () => dispatch(clearAuthFlags()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MegaNav)
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/MegaNav/index.jsx